import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import api from '../services/api.js';
import { useAuth } from '../context/AuthContext.jsx';
import { ROLES } from '../config/menuData.js';

const REPORT_PATH = '/daily-tug-report';

/** "Today's report is due" — shown to captains and chief engineers on every
 * page until their own section is saved. */
export default function ReportDueBanner() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [due, setDue] = useState(null);
  const roles = user?.roles || [];
  const reports = roles.includes(ROLES.CAPTAIN) || roles.includes(ROLES.ENGINEER);

  useEffect(() => {
    if (!reports || pathname === REPORT_PATH) {
      setDue(null);
      return;
    }
    api
      .getMyDtr(undefined, localStorage.getItem('tugos.dtr.tugId') || undefined)
      .then((r) => {
        const mine = r.canEdit.deck ? 'deck' : r.canEdit.engine ? 'engine' : null;
        setDue(mine && !r.sections[mine].savedAt && !r.locked ? { tug: r.tug.name, section: mine } : null);
      })
      .catch(() => setDue(null)); // unassigned or offline: no banner
  }, [reports, pathname]);

  if (!due) return null;
  return (
    <div className="alert alert-warning d-flex justify-content-between align-items-center m-3 mb-0" role="status" data-testid="report-due-banner">
      <span>Today&apos;s Daily Tug Report for {due.tug} is due ({due.section} section).</span>
      <Link className="btn btn-sm btn-warning" to={REPORT_PATH}>Open report</Link>
    </div>
  );
}
